import type { EventUnsubscribe } from '@spotar/runtime';
import type { ClickManager } from '../click-manager';
import { readObjectRefId } from '../helper/object-ref';

let _clickManager: ClickManager | null = null;

export function initOnClickImplementation(clickManager: ClickManager) {
  _clickManager = clickManager;
}

/** Throws on setup problems so EventNode reports an event that can never fire. */
export function subscribeToPointerHits(
  targetId: string,
  triggerOutPortFunctions: Map<string, () => void>
): EventUnsubscribe {
  const clickManager = _clickManager;
  if (!clickManager) throw new Error('click handling is not initialised for this scene');

  const onPointerHit = (event: Event) => {
    if ((event as CustomEvent<string>).detail !== targetId) return;
    triggerOutPortFunctions.get('exec')?.();
  };

  clickManager.addEventListener('onPointerHit', onPointerHit);
  return () => clickManager.removeEventListener('onPointerHit', onPointerHit);
}

export function runOnClickImplementation(
  data: Record<string, unknown>,
  triggerOutPortFunctions: Map<string, () => void>
) {
  const targetId = readObjectRefId(data.target);
  if (!targetId) throw new Error('no target object is set on this node');

  return subscribeToPointerHits(targetId, triggerOutPortFunctions);
}
